import Echo from "laravel-echo"
import store from "@/store/index"
import helpers from "@/helpers/index"

let kioskMainEchoInstance = null
let kioskActivePassEchoInstance = null

const initKioskModeSockets = () => {
  let EchoInstance = null

  window.io = require("socket.io-client")
  EchoInstance = new Echo({
    broadcaster: "socket.io",
    host: import.meta.env.VITE_WS_HOST,
    encrypted: import.meta.env.VITE_WS_ENCRYPTED === "true",
    transports: ["websocket"]
  })

  const directLoginToken = localStorage.getItem("kioskDirectLoginToken")

  EchoInstance.channel(`kiosks.${directLoginToken}`).listen(
    "Tardy\\KioskLatePassCreationToggled",
    (payload) => {
      store.commit("kiosks/SET_ACTIVE_KIOSK_LATES", payload.values)
    }
  )

  kioskMainEchoInstance = EchoInstance
}
const initKioskModePreferencesChannel = () => {
  kioskMainEchoInstance
    .channel(`user.preferences.kiosk`)
    .listen("ProfilePreferencesKioskEvent", () => {
      store.dispatch("favorites/getFavorites", { clearCacheEntry: true })
    })
}
const initKioskModePassSockets = (id) => {
  if (!localStorage.getItem("kioskAccessToken")) {
    return
  }

  let EchoInstance = null

  window.io = require("socket.io-client")
  EchoInstance = new Echo({
    broadcaster: "socket.io",
    host: import.meta.env.VITE_WS_HOST,
    authEndpoint: `${import.meta.env.VITE_AUTH_URL}/broadcasting/auth`,
    encrypted: import.meta.env.VITE_WS_ENCRYPTED === "true",
    auth: {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("kioskAccessToken")
      }
    },
    transports: ["websocket"]
  })

  const kioskUserPassChannel = EchoInstance.private(`kiosks.user.${id}`)

  kioskUserPassChannel.listen(
    "QueueManagement\\QueuePassCanceled",
    (payload) => {
      // eslint-disable-next-line no-console
      console.log("QueueManagement \\ QueuePassCanceled", payload)
      if (payload?.queuePass) {
        store.commit("kiosks/SET_CLOSE_KIOSK_ACTIVE_PASS_SCREEN", true)
      } else {
        store.commit("kiosks/SET_CLOSE_KIOSK_ACTIVE_PASS_SCREEN", false)
      }
      if (payload?.notifyStudent) {
        helpers.playNotificationSound({ playQueueSound: true })
      }
    }
  )

  kioskUserPassChannel.listen("QueueManagement\\QueuePassMoved", (payload) => {
    // eslint-disable-next-line no-console
    console.log("QueueManagement \\ QueuePassMoved", payload)
    if (payload?.queuePass) {
      store.commit("kiosks/REPLACE_ACTIVE_PASS", payload?.queuePass)
      if (payload?.notifyStudent) {
        helpers.playNotificationSound({ playQueueSound: true })
      }
    }
  })

  kioskUserPassChannel.listen(
    "QueueManagement\\QueuePassConverted",
    (payload) => {
      // eslint-disable-next-line no-console
      console.log("QueueManagement \\ QueuePassConverted", payload)
      if (payload?.pass) {
        store.commit("kiosks/REPLACE_ACTIVE_PASS", payload?.pass)
        if (payload?.notifyStudent) {
          helpers.playNotificationSound({ playQueueSound: true })
        }
      }
    }
  )

  kioskUserPassChannel.listen("PassApproved", (payload) => {
    if (payload && payload.pass) {
      store.commit("kiosks/REPLACE_ACTIVE_PASS", payload.pass)
    }
  })

  kioskActivePassEchoInstance = EchoInstance
}
const destroyKioskModePassSockets = () => {
  kioskActivePassEchoInstance.disconnect()
}

export {
  initKioskModeSockets,
  initKioskModePreferencesChannel,
  initKioskModePassSockets,
  destroyKioskModePassSockets
}
